import { render, staticRenderFns } from "./catToUpload.vue?vue&type=template&id=5ad351f4&scoped=true"
import script from "./catToUpload.vue?vue&type=script&lang=js"
export * from "./catToUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad351f4",
  null
  
)

export default component.exports